/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Compare_DescriptionInputs */

const en_meta_compare_description = /** @type {(inputs: Meta_Compare_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What makes Listening different from other text-to-speech apps: it skips citations, imports from Zotero, adds AI overviews and key points, and works on every device.`)
};

const es_meta_compare_description = /** @type {(inputs: Meta_Compare_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué hace diferente a Listening de otras apps de texto a voz: omite las citas, importa desde Zotero, añade resúmenes y puntos clave con IA y funciona en todos tus dispositivos.`)
};

/**
* | output |
* | --- |
* | "What makes Listening different from other text-to-speech apps: it skips citations, imports from Zotero, adds AI overviews and key points, and works on every ..." |
*
* @param {Meta_Compare_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_compare_description = /** @type {((inputs?: Meta_Compare_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Compare_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_compare_description(inputs)
	return en_meta_compare_description(inputs)
});